import { gql } from '@apollo/client'

const CREATE_MANY_NONPROFIT_ORG_USERS = gql`
  mutation createManyNonprofitOrgUsers(
    $nonprofitUserInfo: GranteeUserBasicInput!
    $nonprofitOrgId: Int!
    $sendInvite: Boolean
    $inviteType: NonprofitOrgInviteType
  ) {
    createManyNonprofitOrgUsers(
      nonprofitUserInfo: $nonprofitUserInfo
      nonprofitOrgId: $nonprofitOrgId
      sendInvite: $sendInvite
      inviteType: $inviteType
    ) {
      email
    }
  }
`

export default CREATE_MANY_NONPROFIT_ORG_USERS
